<template>
  <div>
    <div class="box" :value="confirmEvent">
      <div class="border-box">
        <div class="inner-box">
          <div class="box-left">
            <BTree @clickCheckbox="clickCheckbox" :treeData="treeData" />
          </div>
          <div class="box-right">
            已选{{ classNum }}班，已选{{ studentNum }}人
            <BTreeDel @deleteCheckbox="clickCheckbox" :treeData="treeData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BTree from "../../components2/BTree";
import BTreeDel from "../../components2/BTreeDel";

export default {
  name: "MajorAddDialog",
  props: {
    data: Object,
    confirmEvent: Boolean,
  },
  components: {
    BTree,
    BTreeDel,
  },
  watch: {
    confirmEvent() {
      if (this.confirmEvent === true || this.confirmEvent === null) {
        this.close();
      }
    },
  },
  data() {
    return {
      returnData:[],
      treeData: [],
      array: [],
      classNum:0,
      studentNum:0,
    };
  },
  mounted() {
    if (
      this.data.treeData !== null &&
      this.data.treeData !== "" &&
      this.data.treeData !== undefined
    ) {
      this.treeData = this.data.treeData;
      for(var dto of this.treeData){
        if(dto.checked){
          this.classNum = this.classNum+1
        }
        for(var stu of dto.children){
          if(stu.checked){
            this.studentNum = this.studentNum+1
          }
        }
      }
    }
  },
  methods: {
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    clickCheckbox(value) {
      var num = 0
      this.array = value.array
      this.classNum = this.array.length
      for(var dto of this.array ){
        num = num+dto.studentCheckedList.length
      }
      this.studentNum = num
    },
    close(){
      var array = [];
      for (var a = 0; a < this.treeData.length; a++) {
        if (this.treeData[a].checked == true) {
          var studentCheckedList = [];
          var checkedObject = {};
          checkedObject.classId = this.treeData[a].id;
          for (var c = 0; c < this.treeData[a].children.length; c++) {
            if (this.treeData[a].children[c].checked == true) {
              studentCheckedList.push(this.treeData[a].children[c].id);
            }
          }
          checkedObject.studentCheckedList = studentCheckedList;
          array.push(checkedObject);
        }
      }
      var obj = {};
      obj.array = array;
      obj.treeData = this.treeData;
      this.result(obj)
      // 关闭弹层
      this.$emit("input", false);
    }
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.border-box {
  display: flex;
  min-width: 600px;
  width: 50vw;
  height: 350px;
  margin: 10px 0 30px 0;
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
}

.box-left {
  min-width: 280px;
  width: 40%;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  min-width: 280px;
  width: 40%;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  padding-top: 0.5em;
  padding-left: 1em;
}
</style>
